import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Container, Box, Card, CardActions, Button } from '@material-ui/core'
import { MoreHoriz, Clear, Check } from '@material-ui/icons'
import { Link } from 'react-router-dom'
import { Badge, Select, Space } from 'antd'
import moment from 'moment'
import "../admin/styles/listRequest.css"
import { getPaginationRequest, getRequestBeneficiary, getRequestBeneficiaryFiltered } from '../../helpers/admin/getRequestBeneficiary'
import { BeneficiaryCardDetail } from './BeneficiaryTransferRequestDetail'
import { FilterOutlined } from '@ant-design/icons'
import { types } from '../../types/types'
import { traslateStateItem } from '../../services/traslateStateName.service'

export const BeneficiaryTransferRequestsStatus = ({ status }) => {
    switch (status) {
        case "IN_PROGRESS":
            return <MoreHoriz fontSize='large' color='primary' />
        case 'ACCEPTED':
            return <Check fontSize='large' color='action' />
        case 'REJECTED':
            return <Clear fontSize='large' color='error' />
        default:
            return null
    }
}
const { Option } = Select;

const FIXED_STATES = [
    { name: 'IN_PROGRESS', pseudoName: 'EN PROGRESO' },
    { name: 'ACCEPTED',    pseudoName: 'ACEPTADO' },
    { name: 'REJECTED',    pseudoName: 'RECHAZADO' },
];



export const BeneficiaryTransferRequestsItems = ({ item }) => {
    const date = moment(item.requestDate)
    return (
        <Box className="animate__animated animate__fadeInUpBig" component='section' mb={3}>
            <Badge.Ribbon text={traslateStateItem(item.state)}>
                <Card>
                    <BeneficiaryCardDetail
                        date={date.format('YYYY-MM-DD HH:mm:ss')}
                        comment={item.requestComment}
                        name={item.userRequesting}
                        state={item.state}
                    />
                    <CardActions>
                        <Link to={`/user/beneficiary/transfer/request/${item.requestId}`}>
                            <Button variant='outlined'>ver mas</Button>
                        </Link>
                    </CardActions>
                </Card>
            </Badge.Ribbon>
        </Box>
    )
}

export const ListOfBeneficiaryTransferRequests = () => {

    const [listBeneficiaryRequest, setListBeneficiaryRequest] = useState([]);
    const [listBeneficiaryRequestFiltered, setListBeneficiaryRequestFiltered] = useState([]);
    const [filtersAplicated, setFiltersAplicated] = useState({ user: null, date: null, state: null });
    const [loading, setLoading] = useState(false);
    const [tokenNext, setNextToken] = useState(undefined);
    const [lastTokenId, setLastTokenId] = useState(undefined);
    const [tokenPrev, setPrevToken] = useState(undefined);
    const [paginationSize, setPaginationSize] = useState(20);
    const { agreements } = useSelector(state => state.auth);

    /* NUEVO */
    const [currentList, setCurrentList] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [userInputValue, setUserInputValue] = useState('');
    const [dateInputValue, setDateInputValue] = useState('');
    const [dateError, setDateError] = useState(false);
    const isFirstFiltersRender = useRef(true);
    const isFirstPaginationSizeRender = useRef(true);


    /* NUEVO */


    useEffect(
        () => {
            setLoading(true);
            getRequestBeneficiary({ pageNumber: 1, pageSize: paginationSize })
                .then(
                    requestData => {
                        const items = (requestData.Items || [])
                            .sort((a, b) => new Date(b.requestDate) - new Date(a.requestDate));
                        setListBeneficiaryRequest(items);
                        setCurrentList(items);
                        setTotalPages(requestData.totalPages || 1);
                    }
                )
                .finally(() => setLoading(false));
        },
        []
    )

    const handlePageChange = (page) => {
        setPageNumber(page);
        setLoading(true);
        getRequestBeneficiaryFiltered({
            userFilter: filtersAplicated.user,
            dateFilter: filtersAplicated.date,
            stateFilter: filtersAplicated.state,
            pageNumber: page,
            pageSize: paginationSize
        })
            .then(requestData => {
                const items = (requestData.Items || [])
                    .sort((a, b) => new Date(b.requestDate) - new Date(a.requestDate));
                setCurrentList(items);
                setTotalPages(requestData.totalPages || 1);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (isFirstFiltersRender.current) {
            isFirstFiltersRender.current = false;
            return;
        }
        setLoading(true);
        setPageNumber(1);
        getRequestBeneficiaryFiltered({
            userFilter: filtersAplicated.user,
            dateFilter: filtersAplicated.date,
            stateFilter: filtersAplicated.state,
            pageNumber: 1,
            pageSize: paginationSize
        })
            .then(requestData => {
                const items = (requestData.Items || [])
                    .sort((a, b) => new Date(b.requestDate) - new Date(a.requestDate));
                setCurrentList(items);
                setTotalPages(requestData.totalPages || 1);
            })
            .finally(() => setLoading(false));
    }, [filtersAplicated])

    useEffect(() => {
        if (isFirstPaginationSizeRender.current) {
            isFirstPaginationSizeRender.current = false;
            return;
        }
        setLoading(true);
        setPageNumber(1);
        getRequestBeneficiaryFiltered({
            userFilter: filtersAplicated.user,
            dateFilter: filtersAplicated.date,
            stateFilter: filtersAplicated.state,
            pageNumber: 1,
            pageSize: paginationSize
        })
            .then(requestData => {
                const items = (requestData.Items || [])
                    .sort((a, b) => new Date(b.requestDate) - new Date(a.requestDate));
                setCurrentList(items);
                setTotalPages(requestData.totalPages || 1);
            })
            .finally(() => setLoading(false));
    }, [paginationSize])

    const handlerOnFilterSelected = (data, allData) => {
        if (data) {

            const nameKey = allData.key.substring(0, allData.key.indexOf("-"));

            if (nameKey === "userRequesting")
                setFiltersAplicated({ ...filtersAplicated, user: data });
            else if (nameKey === "requestDate") {
                setFiltersAplicated({ ...filtersAplicated, date: data });
            }
            else
                setFiltersAplicated({ ...filtersAplicated, state: data });

            if (typeof data === "number") {

            }
        }
    }

    const handlerOnFilterSelectedPag = (data) => {

        if (data) {

            if (typeof data === "number") {

            }
            setPaginationSize(data);
        }
    }
    if (loading && ListOfBeneficiaryTransferRequests.length === 0)
        return (<strong>Cargando...</strong>)

    const generateList = (list) => {
        return list.map(
            (request, index) => (
                <BeneficiaryTransferRequestsItems key={`${index}`} item={request} />
            )
        )
    }

    /*const generatePagination = (listBeneficiaryRequestFiltered) => {
        const buttonCount = Math.ceil(listBeneficiaryRequestFiltered.length / paginationSize);
        const totalPages = [];
        for (let i = 0; i < buttonCount; i++) {
            totalPages.push(1);
        }
        return totalPages.map((item, index) => {
            return <button className={index === pageNumber ? 'currentPage paginationPage' : 'paginationPage'} onClick={() => { setPageNumber(index); setCurrentList(listBeneficiaryRequestFiltered.slice(index * paginationSize, paginationSize * (index + 1))) }}>{index + 1}</button>
        })
    }*/

    const generatePagination = () => {
        const maxButtons = 10;
        const halfMaxButtons = Math.floor(maxButtons / 2);
        let startPage = 1;
        let endPage = totalPages;

        // Ajustar el rango de páginas a mostrar según la página actual
        if (pageNumber > halfMaxButtons + 1) {
            startPage = pageNumber - halfMaxButtons;
            endPage = pageNumber + halfMaxButtons;
            if (endPage > totalPages) endPage = totalPages;
        } else {
            endPage = Math.min(maxButtons, totalPages);
        }

        const paginationButtons = Array.from({ length: endPage - startPage + 1 }, (_, index) => {
            const page = startPage + index;
            return (
                <button
                    key={page}
                    className={page === pageNumber ? 'currentPage paginationPage' : 'paginationPage'}
                    onClick={() => handlePageChange(page)}
                >
                    {page}
                </button>
            );
        });

        // Agregar botón para ir al inicio
        paginationButtons.unshift(
            <button
                key="start"
                className="paginationPage"
                disabled={pageNumber === 1}
                onClick={() => handlePageChange(1)}
            >
                &lt;&lt;
            </button>
        );

        // Agregar botón para ir al final
        paginationButtons.push(
            <button
                key="end"
                className="paginationPage"
                disabled={pageNumber === totalPages}
                onClick={() => handlePageChange(totalPages)}
            >
                &gt;&gt;
            </button>
        );

        return paginationButtons;
    };



    const unicValues = (key) => {
        if (key === "requestDate") {
            const values = listBeneficiaryRequest.map(data => {
                const d = new Date(data[key]);
                const month = String(d.getUTCMonth() + 1).padStart(2, '0');
                return `${d.getUTCFullYear()}-${month}`;
            });
            return [...new Set(values)];
        } else if (key === "userRequesting") {
            const values = listBeneficiaryRequest.map(data => data[key]).filter(Boolean);
            return [...new Set(values)];
        } else {
            const values = listBeneficiaryRequest.map(data => data[key]);
            return [...new Set(values)].map(state => types[state]);
        }
    }

    const onClearUser = (e) => {
        setFiltersAplicated({ ...filtersAplicated, user: null });
    }
    const onClearDate = (e) => {
        setFiltersAplicated({ ...filtersAplicated, date: null });
    }
    const onClearState = (e) => {
        setFiltersAplicated({ ...filtersAplicated, state: null });
    }

    return (
        <Container className="animate__animated animate__fadeIn" fixed>
            {
                (listBeneficiaryRequest.length > 0) &&
                (
                    <div style={{ display: 'flex', padding: 8, backgroundColor: "rgba(0,0,0,0.1)" }}>
                        <Space size="middle">
                            <div style={{ width: 276 }}>
                                <label htmlFor="user"><FilterOutlined /> Usuario</label>
                                <input
                                    type="text"
                                    id="user"
                                    name="userRequesting"
                                    placeholder="Filtrar por usuario"
                                    style={{ width: "100%", padding: "4px 8px", border: "1px solid #d9d9d9", borderRadius: 4, boxSizing: "border-box" }}
                                    value={userInputValue}
                                    onChange={(e) => setUserInputValue(e.target.value)}
                                    onBlur={(e) => setFiltersAplicated({ ...filtersAplicated, user: e.target.value || null })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') setFiltersAplicated({ ...filtersAplicated, user: e.target.value || null });
                                        if (e.key === 'Escape') { setUserInputValue(''); setFiltersAplicated({ ...filtersAplicated, user: null }); }
                                    }}
                                />
                            </div>

                            <div style={{ width: 276 }}>
                                <label htmlFor="date"><FilterOutlined /> Fecha</label>
                                <input
                                    type="text"
                                    id="date"
                                    name="requestDate"
                                    placeholder="aaaa-mm"
                                    style={{ width: "100%", padding: "4px 8px", border: `1px solid ${dateError ? 'red' : '#d9d9d9'}`, borderRadius: 4, boxSizing: "border-box" }}
                                    value={dateInputValue}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        setDateInputValue(val);
                                        if (/^\d{4}-\d{2}$/.test(val)) {
                                            setDateError(false);
                                            setFiltersAplicated({ ...filtersAplicated, date: val });
                                        } else if (val === '') {
                                            setDateError(false);
                                            setFiltersAplicated({ ...filtersAplicated, date: null });
                                        } else {
                                            setDateError(true);
                                        }
                                    }}
                                />
                                {dateError && <span style={{ color: 'red', fontSize: 12 }}>Formato requerido: aaaa-mm</span>}
                            </div>

                            <div style={{ width: 276 }}>
                                <label htmlFor="state"><FilterOutlined /> Estado</label>
                                <Select
                                    placeholder="Filtrar por estado"
                                    onChange={(data, allData) => handlerOnFilterSelected(data, allData)}
                                    style={{ width: "100%" }}
                                    className="stateControl"
                                    id="state"
                                    name="state"
                                    allowClear
                                    value={filtersAplicated.state || undefined}
                                    onClear={onClearState}
                                >
                                    {
                                        FIXED_STATES.map((data, i) =>
                                            (<Option key={`state-${i}`} value={data.name}>{data.pseudoName}</Option>)
                                        )
                                    }
                                </Select>
                            </div>
                            <div style={{ width: 276 }}>
                                <label htmlFor="state"><FilterOutlined />Cantidad de items</label>
                                <Select
                                    placeholder="Filtrar por estado"
                                    onChange={(data) => handlerOnFilterSelectedPag(data)}
                                    style={{ width: "100%" }}
                                    className="stateControl"
                                    id="state"
                                    name="state"
                                    allowClear
                                    onClear={onClearState}
                                    defaultValue={paginationSize}
                                >

                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </Select>
                            </div>
                        </Space>

                    </div>
                )
            }
            <Box component='div' my={3}>
                {generateList(currentList)}
                {(currentList.length > 0) && generatePagination()}
            </Box>


        </Container>
    )
}
